export const filterCategoryExpense = [
  {
    name: "user",
    value: [
      ["user", "id"],
      ["receiver", "id"],
    ],
    label: [
      ["user", "fullName"],
      ["receiver", "fullName"],
    ],
  },
  {
    name: "category",
    value: [["category", "id"]],
    label: [["category", "name"]],
  },
  {
    name: "Status",
    optionsList: [
      {
        value: 0,
        label: "Receiver Pending",
        color: "text-yellow-500",
      },
      {
        value: 1,
        label: "Supervisor Pending",
        color: "text-yellow-500",
      },
      {
        value: -1,
        label: "Rejected By Receiver",
        color: "text-red-1",
      },
      {
        value: 3,
        label: "Accepted By Supervisor",
        color: "text-green",
      },
      {
        value: -3,
        label: "Rejected By Supervisor",
        color: "text-red-1",
      },
      {
        value: 7,
        label: "Accepted By Admin",
        color: "text-green",
      },
      {
        value: -7,
        label: "Rejected By Admin",
        color: "text-red-1",
      },
      {
        value: 15,
        label: "Accept By Company",
        color: "text-green",
      },
      {
        value: -15,
        label: "Rejected By Company",
        color: "text-red-1",
      },
    ],
    valueAddress: [["state"]],
    isStatic: true,
    unsort: true,
  },
];

export const filterCategoryExpensePending = [
  {
    name: "user",
    value: [
      ["user", "id"],
      ["receiver", "id"],
    ],
    label: [
      ["user", "fullName"],
      ["receiver", "fullName"],
    ],
  },
  {
    name: "category",
    value: [["category", "id"]],
    label: [["category", "name"]],
  },
];

export const filterCategorySite = [
  {
    name: "site engineer",
    value: [["jbccFieldTechnician", "id"]],
    label: [["jbccFieldTechnician", "fullName"]],
  },
  {
    name: "subdivision",
    value: [["je", "subDivision", "id"]],
    label: [["je", "subDivision", "name"]],
  },
  {
    name: "JE",
    value: [["je", "id"]],
    label: [["je", "name"]],
  },
  {
    name: "category",
    value: [["category", "id"]],
    label: [["category", "name"]],
  },
];

export const filterCategorySearch = [
  {
    name: "category",
    value: [["category", "id"]],
    label: [["category", "name"]],
  },
];
export const filterCategoryCylinderSite = [
  {
    name: "Station",
    value: [["id"]],
    label: [["name"]],
  },
  {
    name: "Field Technician",
    value: [["jbccFieldTechnician", "id"]],
    label: [["jbccFieldTechnician", "fullName"]],
  },
];

export const SITE_REPAIRS_FILTERS = [
  {
    name: "Field Technician",
    value: [["station","jbccFieldTechnician", "id"]],
    label: [["station","jbccFieldTechnician", "fullName"]],
  },
  {
    name: "Supervisor",
    value: [["station", "jbccFieldTechnician", "jbccSupervisor", "id"]],
    label: [["station", "jbccFieldTechnician", "jbccSupervisor", "fullName"]],
  },
  {
    name: "Subdivision",
    value: [["station", "je", "subDivision", "id"]],
    label: [["station", "je", "subDivision", "name"]],
  },
];
